import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const ADMIN_PASSWORD = "S4n70.4dm1n";
const ADMIN_USER = "AdminS7P";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");

  useEffect(() => {
    document.body.classList.add("admin-page");
    return () => {
      document.body.classList.remove("admin-page");
    };
  }, []);
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setTimeout(() => {
      if (username === ADMIN_USER && password === ADMIN_PASSWORD) {
        sessionStorage.setItem("sp_admin_auth", "true");
        navigate("/admin");
      } else {
        setError("Usuario o contraseña incorrectos.");
      }
      setLoading(false);
    }, 700);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#f0fbfc] via-[#fdf6ff] to-[#fff0f5]">
      <div className="w-full max-w-md px-4">
        <div className="bg-white rounded-2xl p-10 border border-[#c9b8f0]/30">
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#00b4c8]/10 mb-4">
              <i className="ri-lock-2-line text-[#00b4c8] text-2xl"></i>
            </div>
            <h1 className="text-2xl font-bold text-[#2d1a0e] tracking-tight">
              Panel Administrador
            </h1>
            <p className="text-sm text-[#6b5b6e] mt-1">San7o Pecado — Acceso privado</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-xs font-semibold text-[#7c5cbf] uppercase tracking-wider mb-1.5">
                Usuario
              </label>
              <div className="relative">
                <span className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-[#00b4c8]">
                  <i className="ri-user-line text-base"></i>
                </span>
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="w-full pl-10 pr-4 py-3 rounded-lg border border-[#c9b8f0]/50 bg-[#fdf6ff] text-sm text-[#2d1a0e] focus:outline-none focus:border-[#00b4c8] transition-colors"
                  placeholder="admin"
                  required
                />
              </div>
            </div>

            <div>
              <label className="block text-xs font-semibold text-[#7c5cbf] uppercase tracking-wider mb-1.5">
                Contraseña
              </label>
              <div className="relative">
                <span className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-[#00b4c8]">
                  <i className="ri-key-line text-base"></i>
                </span>
                <input
                  type={showPass ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full pl-10 pr-10 py-3 rounded-lg border border-[#c9b8f0]/50 bg-[#fdf6ff] text-sm text-[#2d1a0e] focus:outline-none focus:border-[#00b4c8] transition-colors"
                  placeholder="••••••••"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPass(!showPass)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-[#6b5b6e] hover:text-[#00b4c8] cursor-pointer transition-colors"
                >
                  <i className={showPass ? "ri-eye-off-line text-base" : "ri-eye-line text-base"}></i>
                </button>
              </div>
            </div>

            {error && (
              <div className="flex items-center gap-2 bg-red-50 border border-red-200 rounded-lg px-4 py-3">
                <span className="w-4 h-4 flex items-center justify-center text-red-500">
                  <i className="ri-error-warning-line text-sm"></i>
                </span>
                <p className="text-sm text-red-600">{error}</p>
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#00b4c8] hover:bg-[#0099aa] text-white font-semibold py-3 rounded-lg text-sm transition-colors cursor-pointer whitespace-nowrap disabled:opacity-60"
            >
              {loading ? (
                <span className="flex items-center justify-center gap-2">
                  <i className="ri-loader-4-line animate-spin text-base"></i>
                  Verificando...
                </span>
              ) : (
                "Ingresar al Panel"
              )}
            </button>
          </form>

          <p className="text-center text-xs text-[#6b5b6e] mt-6">
            <a href="/" className="hover:text-[#d4607a] transition-colors">
              ← Volver al sitio web
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
